/**
 * @file 通用 container
 * @author chris<wfsr@foxmail.com>
 */

import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import {ConfigProvider} from 'lark';
import App from './App';
import store from './store';

const render = Component => {
    ReactDOM.render(
        <ConfigProvider autoInsertSpaceInButton={false}>
            <Provider store={store}>
                <Router>
                    <Component />
                </Router>
            </Provider>
        </ConfigProvider>,
        document.getElementById('app')
    );

    return render;
};

render(App);
